import React,{ useEffect } from 'react';

const Home = () => {

    useEffect(() => {
        window.location.href = "hhttps://www.marathonkuching.com/";
    }, []);

    return (
        <>
            <h1>Home</h1>
        </>
    );
}

export default Home;